
import * as React from 'react';
import TransferTooltip from '../../TransferTooltip/TransferTooltip';
import ResponseTooltip from '../../ResponseTooltip';
import DetailsTooltip from '../../DetailsTooltip';

export const setTooltip = (transfer, panel) => {
  if(transfer) {
    return <TransferTooltip />;
  } else if(panel === "details") {
    return <DetailsTooltip />
  } else
    return <ResponseTooltip />;
}


// WEBPACK FOOTER //
// ./src/components/AreaChart/utils/setTooltip.js